export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    /**
     * The backend's `data` on a failed response — for a rejected request that
     * is its `ValidationDetails`, naming the fields that failed and why.
     *
     * Carried because dropping it made every backend validation error read as
     * the same unactionable "check the highlighted fields": `VALIDATION_FAILED`
     * puts a generic sentence in `message` and the field list in `data`, so an
     * error that only kept `message` told the caller nothing. Diagnosing one
     * previously meant patching the backend's `exceptionFactory` to log the
     * errors to a file.
     */
    public readonly details?: unknown,
    /**
     * The backend's Retry-After, in seconds, on a refusal that says when to come back (a busy
     * report queue's 503, Change saturation stress run 2, R4-1). The proxy passes it on.
     */
    public readonly retryAfter?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
